import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatErr, LOGO_URL } from "@/lib/api";

const BG = "https://images.pexels.com/photos/37610897/pexels-photo-37610897.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940";
const LOGO = LOGO_URL;

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@skalartech.de");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/modules" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Willkommen zurück");
      nav("/modules");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Anmeldung fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-white">
      <div
        className="hidden lg:flex relative items-end p-12 text-white"
        style={{
          background: `linear-gradient(135deg, rgba(10,37,64,0.85), rgba(10,37,64,0.55)), url(${BG}) center/cover no-repeat`,
        }}
      >
        <div>
          <div className="text-xs uppercase tracking-[0.3em] opacity-70 mb-4">SKALARTECH</div>
          <h1 className="text-5xl font-bold leading-tight max-w-lg">
            Leistungs&shy;abrechnung &amp;<br />Aufmaß Management
          </h1>
          <p className="text-sm opacity-75 mt-6 max-w-md">
            Verwaltung von Telekom FTTH-, GWV- und NE4-Aufträgen.
            Automatische Mitarbeiterabrechnung, KI-gestützte Screenshot-Erkennung, Aufmaßverwaltung.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
          <div className="flex items-center justify-center mb-6">
            <img src={LOGO} alt="SKALARTECH" className="h-32 w-auto" />
          </div>

          <h2 className="text-2xl font-bold mb-2 text-center">Willkommen zurück</h2>
          <p className="text-sm text-slate-500 mb-8 text-center">Bitte melden Sie sich mit Ihrem Konto an.</p>

          <div className="space-y-4">
            <div>
              <Label htmlFor="email">E-Mail</Label>
              <Input
                id="email"
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="h-12 mt-1.5"
                required
              />
            </div>
            <div>
              <Label htmlFor="password">Passwort</Label>
              <Input
                id="password"
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="h-12 mt-1.5"
                required
              />
            </div>
            <Button
              data-testid="login-submit"
              type="submit"
              disabled={loading}
              className="h-12 w-full bg-[#0A2540] hover:bg-[#113A63] text-white font-semibold"
            >
              {loading ? "Anmelden…" : "Anmelden"}
            </Button>
          </div>

          <div className="mt-8 text-xs text-slate-400">
            © {new Date().getFullYear()} SKALARTECH GmbH
          </div>
        </form>
      </div>
    </div>
  );
}
